import { useMemo } from 'react';

/**
 * Hook to check if user has trained today
 * @param {Array} todayTrainings - Array of training sessions from today
 * @returns {boolean} - True if user has trained today, false otherwise
 */
export const useHasTrainedToday = (todayTrainings) => {
  return useMemo(() => {
    if (!todayTrainings || !Array.isArray(todayTrainings)) {
      return false;
    }
    return todayTrainings.length > 0;
  }, [todayTrainings]);
};

export default useHasTrainedToday;

